import { render } from "./invoiceRecords.vue?vue&type=template&id=65c13fb0&scoped=true"
import script from "./invoiceRecords.vue?vue&type=script&lang=js"
export * from "./invoiceRecords.vue?vue&type=script&lang=js"

import "./invoiceRecords.vue?vue&type=style&index=0&id=65c13fb0&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c13fb0"]])

export default __exports__